import { DialogWrapper } from "@bridgesplit/ui";
import { AppDialog, useAppDialog } from "app/utils";
import { DialogHeader } from "app/components/common";
import { COPY } from "app/constants";

import { VaultExternalRewardsClaimCta } from "../external-rewards";

export function VaultClaimRewardsDialog() {
    const { getData } = useAppDialog();
    const data = getData(AppDialog.VaultClaimRewards);

    return (
        <DialogWrapper>
            <DialogHeader
                header="Claim Rewards"
                description={`Claim additional rewards from a ${
                    COPY.VAULT_TERM
                } ${COPY.VAULT_MANAGER_PREFIX.toLowerCase()} ${data?.vaultExpanded?.vaultMetadata?.managerName}`}
            />

            <VaultExternalRewardsClaimCta vaultExpanded={data?.vaultExpanded} />
        </DialogWrapper>
    );
}
